const styleSheet = () => ({
  backgroundContainer: {
    backgroundColor: '#FFFFFF',
    position: 'relative',
  },
  loader: {
    width: '987px',
    height: '100%',
    backgroundColor: '#FFFFFF',
    position: 'absolute',
    zIndex: 9,
  },
  inputBlockerFirstDashboard: {
    height: '100px',
    width: '987px',
    backgroundColor: '#FFFFFF',
    position: 'relative',
    marginBottom: '-45px',
    zIndex: 8,
  },
  inputBlockerSecondDashboard: {
    height: '45px',
    width: '987px',
    backgroundColor: '#FFFFFF',
    position: 'relative',
    marginBottom: '-45px',
    zIndex: 8,
  },
  dropdownTitle: {
    position: 'absolute',
    top: '36px',
    right: '-17px',
    height: '12px',
    width: '167px',
    color: '#6E7680',
    fontFamily: 'Avenir',
    fontSize: '9px',
    fontWeight: '500',
    letterSpacing: '0',
    lineHeight: '12px',
  },
  dateDescription: {
    position: 'absolute',
    top: '82px',
    height: '13px',
    width: '145px',
    color: '#778491',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '10px',
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '13px',
  },
  dateTo: {
    color: '#94A1AD',
    margin: '0 2px 0 2px',
  },
  calendar: {
    position: 'absolute',
    top: '56px',
    right: '0px',
    cursor: 'pointer',
  },
  blue: {
    '& path': {
      fill: '#085FE5',
    },
  },
  dropdownContainer: {
    position: 'absolute',
    right: '20px',
  },
});

export default styleSheet;
